import React from 'react';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/system';

const theme = createTheme({
  palette: {
    background: {
      paper: '#fff'
    },
    text: {
      primary: '#173A5E',
      secondary: '#46505A'
    },
    action: {
      active: '#001E3C'
    },
    success: {
      dark: '#009688'
    },
    error: {
      dark: '#ef5350'
    }
  }
});

export default function TotalSummary(props) {
  const { title, subtitle, percent, comment, value, unit, children } = props;

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          bgcolor: 'background.paper',
          boxShadow: 1,
          borderRadius: 2,
          p: 2,
          minWidth: 300
        }}
      >
        <Box sx={{ color: 'text.secondary' }}>
          {title}
          {subtitle && <span style={{ fontSize: '12px' }}>{` (${subtitle})`}</span>}
        </Box>
        {(percent || comment) && (
          <Box>
            <Box height="4rem" display="flex" justifyContent="flex-start" alignItems="center">
              {children}
            </Box>
            <Box height="1.5rem">
              <Box
                sx={{
                  color: percent > 0 ? 'success.dark' : 'error.dark',
                  display: 'inline',
                  fontWeight: 'bold',
                  mx: 0.5,
                  fontSize: 14
                }}
              >
                {percent} %
              </Box>
              <Box sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>{comment}</Box>
            </Box>
          </Box>
        )}
        {!percent && !comment && (
          <Box>
            <Box height="5.5rem" display="flex" justifyContent="space-between" alignItems="flex-end">
              {children}
            </Box>
          </Box>
        )}
      </Box>
    </ThemeProvider>
  );
}
